import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQ as FAQ_DATA } from "../data/site";

export default function FAQ() {
    const [open, setOpen] = useState(0);

    return (
        <section
            id="sss"
            data-testid="faq-section"
            className="section bg-[#0a0a0c]"
        >
            <div className="container-x">
                <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
                    <div className="eyebrow mb-4">Sık Sorulanlar</div>
                    <h2 className="h2 text-[#f4efe4]">
                        <span className="gold-text">Merak</span> Edilenler
                    </h2>
                    <div className="divider-gold mt-6 mx-auto" />
                </div>

                <div className="max-w-3xl mx-auto">
                    {FAQ_DATA.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <div
                                key={i}
                                data-testid={`faq-item-${i}`}
                                className="border-b border-[#23232b]"
                            >
                                <button
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    className="w-full flex items-center justify-between gap-4 py-5 text-left"
                                    aria-expanded={isOpen}
                                >
                                    <span className="text-[15px] md:text-[16px] font-medium text-[#f4efe4] pr-4">
                                        {item.q}
                                    </span>
                                    <span
                                        className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center border transition-all ${
                                            isOpen
                                                ? "border-transparent bg-gradient-to-br from-[#f5d685] to-[#8a6a28] text-[#0a0a0c]"
                                                : "border-[#23232b] text-[#c9c2b3]"
                                        }`}
                                    >
                                        {isOpen ? (
                                            <Minus className="w-4 h-4" />
                                        ) : (
                                            <Plus className="w-4 h-4" />
                                        )}
                                    </span>
                                </button>
                                <div
                                    className="grid transition-[grid-template-rows] duration-300 ease-out"
                                    style={{
                                        gridTemplateRows: isOpen ? "1fr" : "0fr",
                                    }}
                                >
                                    <div className="overflow-hidden">
                                        <p className="pb-5 text-[14px] leading-relaxed text-[#b8b1a1] pr-8">
                                            {item.a}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
